<template>
    <div>
        <div id="main" style="width: 600px;height:400px;"></div>
    </div>
</template>
<script>
import echarts from "echarts";
export default {
    data() {
        return {
            
        }
    },
    mounted() {
        var myChart = echarts.init(document.getElementById('main'));
        let ROOT_PATH= 'https://echarts.apache.org'
        let option = {}
        myChart.setOption(option);
        
    }
}
</script>